import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiRadioListModule } from "@taiga-ui/kit";
import { KwikUISafeHtmlPipeModule } from "../../../../pipes/safe-html/safe-html.module";
import { KwikUIInputRadioChipComponent } from "./input-radio-chip.component";

@NgModule({
  declarations: [KwikUIInputRadioChipComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiRadioListModule,
    KwikUISafeHtmlPipeModule
  ],
  exports: [KwikUIInputRadioChipComponent]
})
export class KwikUIInputRadioChipModule {}
